import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import SourceMaterialUpload from "./SourceMaterialUpload";
import ReferenceMaterialUpload from "./ReferenceMaterialUpload";
import {dateFormat, transformBlankToNull, timeStamp} from "../../services/Util";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RotatingLines } from "react-loader-spinner";
import { getAxiosResponse, postAxiosResponse, putAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import Constants from "../../Constants";
import $, { post } from "jquery";
import { Breadcrumb } from "../../components/dashboard/Breadcrumb";
import Select from "react-select";
import DatePickerCalendar from "../../components/dashboard/calendars/DatePickerCalendar";
import ProjectRequestIntegration from "./ProjectRequestIntegration";
import { updateProjectRequestIntegrationValue, resetProjectRequestIntegrationValue } from "../../redux/reducers/ProjectRequestIntegrationSlice";
import DataTable, { createTheme } from "react-data-table-component";
import { getSelectedAssets } from '../../services/IntegrationUtil'
import { handleError } from "../../services/authApiRoutes/APImethods";
import ReactTooltip from "react-tooltip";
import DateFormat from "../../pages/DateFormat";
import dateUtil from "../../services/DateUtil";
import store from "../../redux/store";

export default function EditProjectRequest() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const param = useParams();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(true);
  const projectRequestId = param.id;
  const navigate = useNavigate();
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const theme = aaaSelected ? "dark" : "";

  const priorities = [
    { value: "", label: "Select One" },
    { value: "HIGHEST", label: "Highest (1)" },
    { value: "HIGH", label: "High (2)" },
    { value: "MEDIUM", label: "Medium (3)" },
    { value: "LOW", label: "Low (4)" },
    { value: "LOWEST", label: "Lowest (5)" },
  ];

  const assetColumns = [
    {
      id: "asset.displayName",
      name: "Name",
      selector: (asset) => asset[projectRequestIntegrationRedux.displayName],
      sortable: true,
      cell: (asset) => asset[projectRequestIntegrationRedux.displayName],
    },
    {
      id: "sourceLanguage.display",
      name: "Source Language",
      selector: (asset) => projectRequestIntegrationRedux.sourceLanguage,
      sortable: false,
      cell: (asset) => projectRequestIntegrationRedux.sourceLanguage?.display,
    },
    {
      id: "targetLanguage.display",
      name: "Target Language",
      wrap: false,
      selector: (asset) => asset?.targetLanguages,
      sortable: false,
      cell: (asset) => new String(asset?.targetLanguages?.map(targetLanguage => (targetLanguage?.display))),
    }
  ];

  const translate = t;
  const [isLoading, setIsLoading] = useState(true);
  const [projectRequestData, setProjectRequestData] = useState({});
  const [departments, setDepartments] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [toggleIntialCal, toggleIntialCalFlag] = useState(false);
  const [campaigns, setCampaigns] = useState([]);
  const [poNumbers, setPoNumbers] = useState([]);
  const [tags, setTags] = useState([]);
  const [filteredTags, setFilteredTags] = useState([])
  const [selectedTags, setSelectedTags] = useState([]);
  const [requestName, setRequestName] = useState("");
  const [requestNote, setRequestNote] = useState("");
  const refToggle2 = useRef(null);
  const refCalendar2 = useRef(null);

  const [selectedPONumber, setSelectedPONumber] = useState("");
  const [allAssignedUser, setAllAssignedUser] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [selectedPriority, setSelectedPriority] = useState("");
  const [sourceLanguages, setSourceLanguages] = useState([]);
  const [selectedSourceLanguage, setSelectedSourceLanguage] = useState("");
  const [targetLanguages, setTargetLanguages] = useState([]);
  const [translationDueDate, setTranslationDueDate] = useState("");
  const [filteredTargetLanguage, setFileredTargetLanguage] = useState([]);
  const [selectedTargetLanguages, setSelectedTargetLanguages] = useState([]);
  const [contentType, setContentType] = useState();
  const [contentName, setContentName] = useState();
  const [showIntegration, setshowIntegration] = useState(false);
  const [requestType, setRequestType] = useState("");
  const [sourceMaterialDescription, setSourceMaterialDescription] = useState("");
  const [cancelationNotes, setCancelingNote] = useState("")
  const [cancelationNotesLength, setCancelingNoteLength] = useState(0)

  const ProjectRequestIntegrationMemo = React.memo(ProjectRequestIntegration);
  const projectRequestIntegrationRedux = useSelector((redux) => redux.project_request_integration).value;
  const customerTimeZone = store.getState()?.customer_bootstrap_data?.value?.user?.timeZone;

  const dispatchToProjectRequestIntegrationRedux = (type, value) => {
    dispatch(
      updateProjectRequestIntegrationValue({
        type: type,
        value: value,
      })
    );
  };

  const backRef = useRef();
  const hideModalFun = () => {
    document.body.classList.remove("modal-open-3");
    document.body.classList.remove("modal-open-2");
    document.body.classList.remove("modal-open-5");
    document.body.classList.remove("modal-open-4");
  };
  const hideModal2 = () => {
    document.body.classList.remove("modal-open-5");
    document.body.classList.remove("modal-open-3");
  };
  const selectDepartment = (value) => {
    if (value.value !== "") {
      setSelectedDepartment(value.value);
      setValidationErrors({});
    } else {
      setSelectedDepartment({});
    }
  };
  const sourceDocument = useSelector((projectRequestSourceDocument) => projectRequestSourceDocument.project_request_source_material)?.value;
  const referenceDocument = useSelector((projectRequestReferenceDocument) => projectRequestReferenceDocument.project_request_reference_material)?.value;
  const permissions = useSelector((reduxStore) => reduxStore.customer_bootstrap_data)?.value?.permissions;
  const userBootstrapData = useSelector((reduxStore) => reduxStore.customer_bootstrap_data)?.value;

  const selectCampaign = (value) => {
    if (value.value !== "") {
      setSelectedCampaign(value.value);
    } else {
      setSelectedCampaign({});
    }
  };
  const selectPriority = (value) => {
    if (value.value !== "") {
      setSelectedPriority(value.value);
    } else {
      setSelectedPriority("");
    }
  };
  const selectTag = (value) => {
    let localSelectedTags = selectedTags;
    let duplicatTag = selectedTags?.find(tag => tag?.display === value?.display)
    if (!duplicatTag) {
      localSelectedTags.push(value);
    }
    setSelectedTags(localSelectedTags);

    let tagsLabel = localSelectedTags?.map(tag => tag?.display);
    setFilteredTags(tags.filter(tag => !tagsLabel.includes(tag.label)));
  };

  const selectTagKeyDown = (event) => {
    if (event.code === Constants.ENTER && event.target.value !== '') {
      event.preventDefault()
      console.log('tag',event.target?.value)
      let value = event.target?.value.trim();
      selectTag({ display: value });
    }
  }

  const removeTag = (value,index) => {
    setFilteredTags((current) => [...current, { label: value?.display, value: value }]);
    var remaining = selectedTags.filter(tag => tag?.display !== value?.display);
    setSelectedTags(remaining);
    if(index !== 0 && index === selectedTags.length-1){
      $(`#remove-lang-${index-1}`).trigger('focus')
    }
  };

  const selectPONumber = (value) => {
    if (value.value !== "") {
      setSelectedPONumber(value.value);
    } else {
      setSelectedPONumber("");
    }
  };
  const hideModal = () => {
    hideModal2();
    document.body.classList.remove("modal-open-4");
    $("#eloquaAssets").trigger("focus");
  };
  $(document).on("click", ".openOption", function () {
    $("input:not(:checked)").parent().next().removeClass("checked");
    $("input:checked").parent().next().addClass("checked");
  });
  $(document).on("click", "#eloquaAssets", function () {
    $("input:checked").parents("body").addClass("modal-open");
    document.body.classList.remove("modal-open-5");
    setTimeout(() => {
      $(".first-focus").trigger("focus");
      $(".first-focus").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
          if (e.shiftKey === true) {
            e.preventDefault();
            $("#dasboardBtn").trigger("focus");
          }
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          document.body.classList.remove("modal-open-3");
        }
      });
    }, 500);
  });
  $(document).on("click", "#marketoAssets", function () {
    $("input:checked").parents("body").addClass("modal-open");
    hideModal2();
  });

  const handleKeyAddflow = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $("#dasboardBtn").trigger("focus");
      }
    }
  };
  const showCalendarDiliveryDate = () => {
    toggleIntialCal ? toggleIntialCalFlag(false) : toggleIntialCalFlag(true);
    if (toggleIntialCal) {
      var requiredElement = document.querySelector(".dashCalendarInternal");
      requiredElement.focus();
    }
  };
  const closeCalendar = (e) => {
    if (e.code === "Escape") {
      toggleIntialCalFlag(false);
    }
  };
  const handleTranslationDueDate = (event) => {
    setTranslationDueDate(event);
    refToggle2.current.focus()
    toggleIntialCalFlag(false);
  };

  const handleSourceLanguageChange = (value) => {
    setSelectedSourceLanguage(value.value);
    var remainingTargetLangs = targetLanguages.filter((target) => {
      return target.value.code !== value.value.code;
    });
    var filteredTargetLanguage = selectedTargetLanguages.filter((target) => {
      return target.code !== value.value.code;
    });
    setSelectedTargetLanguages(filteredTargetLanguage);
    setFileredTargetLanguage(remainingTargetLangs);
  };
  const handleTargetLanguageChange = (event) => {
    var selectedLang = event;
    var langArray = [];
    if (selectedLang.value === "all") {
      filteredTargetLanguage.map((langs) => {
        if (langs.value !== "all") {
          langArray.push({ assigneeUser: "", language: [langs.value] });
        }
      });
      setFileredTargetLanguage([]);
      setSelectedTargetLanguages(langArray);
    } else {
      setSelectedTargetLanguages((current) => [...current, { assigneeUser: "", language: [selectedLang.value] }]);
    }



    setTimeout(function () {
      $(".lang-second div button").removeClass("lastFocus");
    }, 900);
    setTimeout(function () {
      $(".lang-second div:last button").addClass("lastFocus");
    }, 1000);
  };

  useEffect(() => {
    if (targetLanguages?.length > 0) {
      let selectedTargs = selectedTargetLanguages.map((lang) => lang.language[0]?.code);
      setFileredTargetLanguage(targetLanguages.filter(lang => !selectedTargs.includes(lang.value?.code) && selectedSourceLanguage?.code !== lang.value?.code));
    }
  }, [selectedTargetLanguages, targetLanguages])

  const removeTargetLanguage = (selected) => {
    var result = selectedTargetLanguages.filter((selectedLangs) => {
      return selectedLangs.language[0].code !== selected.language[0].code;
    });
    setSelectedTargetLanguages(result);
    if ($(".lang-second div").length <= 1) {
      $(".stricy-btn .left div:last button").trigger("focus");
    }
  };
  const getAllData = () => {
    getAxiosResponse(APIUrls.ALL_DEPARTMENT)
      .then((res) => {
        if (res.data !== "") {
          var options = [{ label: "Select One", value: "" }];
          res.data.data.map((depart) => {
            options.push({
              label: depart.name,
              value: depart,
            });
          });
          setDepartments(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.PROJECT_LISTING_PURCHASE_ORDERS)
      .then((res) => {
        if (res.data !== "") {
          var options = [{ label: "Select a PO number", value: "" }];
          res.data.data.map((po) => {
            if (po.poName !== po.poNumber) {
              options.push({
                label: po.poNumber + " (" + po.poName + ")",
                value: po,
              });
            } else {
              options.push({ label: po.poName, value: po });
            }
          });
          setPoNumbers(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.WORKSPACE_LIST + `?onlyMember=false&onlyOpen=true&showProgress=false`)
      .then((res) => {
        if (res.data !== "") {
          var options = [{ label: "Select One", value: "" }];
          res.data.data.result.map((campaign) => {
            options.push({
              label: campaign.name,
              value: campaign,
            });
          });
          setCampaigns(options);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

  useEffect(() => {
    var sourceLangArray = [];
    var targetLangArray = [{ label: "Select All", value: "all" }];

    getAxiosResponse(APIUrls.GET_ACCOUNT_SOURCE_LANGUAGES)
      .then((res) => {
        if (res.data !== "") {
          res.data.data.map((lang) => {
            sourceLangArray.push({
              label: lang?.display,
              value: lang,
            });
          });
          setSourceLanguages(sourceLangArray);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.GET_ACCOUNT_TARGET_LANGUAGES)
      .then((res) => {
        if (res.data !== "") {
          res.data.data.map((lang) => {
            targetLangArray.push({
              label: lang?.display,
              value: lang,
            });
          });
          setTargetLanguages(targetLangArray);
          setFileredTargetLanguage(targetLangArray);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  }, []);

  $(".lang-second div:last button, .lang-first div:last button").addClass("lastFocus");
  $(document).on("click", ".lastFocus", function () {
    $(".stricy-btn .left div:last button").trigger("focus");
  });

  useEffect(() => {
    var selectedTag = [];
    const results = tags.filter(({ value: id1 }) => projectRequestData.tags.some((id2) => id2 === id1?.display));
    results.map((result) => {
      selectedTag.push(result.value);
    });

    setSelectedTags(selectedTag);
  }, [projectRequestData]);

  useEffect(() => {
    let tagsLabel = selectedTags?.map(tag => tag?.display);
    setFilteredTags(tags?.filter(tag => !tagsLabel.includes(tag.label)));
  }, [tags, selectedTags])

  const getProjectData = () => {
    getAxiosResponse(APIUrls.TAGS)
      .then((res) => {
        if (res.data !== "") {
          var options = [];
          res.data.data.result.map((tag) => {
            options.push({
              label: tag?.display,
              value: tag,
            });
          });
          setTags(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.GET_PROJECT_REQUEST(projectRequestId))
      .then((res) => {
        if (res?.data !== "") {
          let projectRequest = res.data.data.resource;
          setProjectRequestData(projectRequest);
          setRequestName(projectRequest.name);
          setSelectedDepartment(projectRequest.userGroup);
          assigneeAllUser(projectRequest?.userGroup?.id)
          setSelectedCampaign(projectRequest.workspace);
          setSelectedPriority(projectRequest.priority);
          setTranslationDueDate(projectRequest.translationDueDate);
          setSelectedPONumber(projectRequest.purchaseOrder);
          setRequestNote(projectRequest.notes);
          setSelectedSourceLanguage(res.data.data.displayName[0].sourceLanguage[0]);
          setSelectedTargetLanguages(res.data.data.displayName[0].requestTargetLanguages);
          setSelectedTags(projectRequest.tags)
          setSourceMaterialDescription(projectRequest.sourceMaterialDescription);

          setLoader(false);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

   const assigneeAllUser=(id)=>{
     postAxiosResponse(APIUrls.PROJECT_REQUEST_ASSIGNE(id),{}).then(res=>{
      let assignedUser = res?.data?.data?.allAssignableUsers;


    const undefinedUser = {
      label: "Undefined",
      value: undefined,  
      data: null,        
    };

    const user = [undefinedUser];

    if (assignedUser && assignedUser?.length > 0) {
      user.push(
        ...assignedUser.map((data) => {
          return {
            label: data?.firstName + " " + data?.lastName,
            value: data?.userId,
            data: data,
          };
        })
      );
    }

    setAllAssignedUser(user);
      }
     ).catch(err=>{
      console.error(err)
     })
   } 


  useEffect(() => {
    getProjectData();
    getAllData();
  }, []);

  const updateRequest = () => {
    var copyProjectData = structuredClone(projectRequestData);

    if (selectedCampaign !== "") {
      selectedCampaign.workspaceMembers = null;
      selectedCampaign.userAndCountResources = null;
      selectedCampaign.projectStatusCount = null;
      selectedCampaign.dueDateInPast = false;
      selectedCampaign.dueDate = null;
    }

    var allTagPayload = [];
    if (selectedTags.length > 0) {
      selectedTags.map((tag) => {
        allTagPayload.push(tag?.display);
      });
    }
    copyProjectData.id = projectRequestId;
    copyProjectData.name = requestName;
    copyProjectData.status = "OPEN";
    copyProjectData.description = null;
    copyProjectData.translationDueDate = timeStamp(translationDueDate, customerTimeZone);
    copyProjectData.requestTargetLanguages =selectedTargetLanguages?.map(data => ({
      language: data?.language[0]?.language,
      assigneeUser: data?.assigneeUser,
      removed: false,
    }));
    
    copyProjectData.sourceMaterial = sourceDocument.length !== 0 ? sourceDocument : null;
    copyProjectData.referenceMaterials = referenceDocument;
    copyProjectData.sourceLanguage = getSourceLanguage();
    copyProjectData.tags = allTagPayload;
    copyProjectData.priority = selectedPriority;
    copyProjectData.workspace = selectedCampaign !== "" ? selectedCampaign : null;
    copyProjectData.supportMultiSource = true;
    copyProjectData.notes = requestNote;
    copyProjectData.purchaseOrder = selectedPONumber;
    copyProjectData.assets = getSelectedAssets(projectRequestIntegrationRedux.contentType, projectRequestIntegrationRedux.selectedAssets, projectRequestIntegrationRedux.sourceLanguage);
    copyProjectData.sourceMaterialDescription = sourceMaterialDescription;
    copyProjectData.requestSourceType = "upload";

    if (selectedDepartment.id !== undefined) {
      copyProjectData.userGroup = { id: selectedDepartment.id };
    }
    var finalPayload = transformBlankToNull(copyProjectData);

    putAxiosResponse(APIUrls.GET_PROJECT_REQUEST(projectRequestId), finalPayload).then((res) => {
      if (Object?.keys(res?.data?.data?.body?.errors)?.length !== 0) {
        setValidationErrors(res?.data?.data?.body?.errors);
      } else {
        navigate(`/project-request/show/${projectRequestId}`);
      }
    });
  };

  const getSourceLanguage = () => {
    let sourceLanguage;
    if (projectRequestIntegrationRedux.sourceLanguage) {
      sourceLanguage = projectRequestIntegrationRedux.sourceLanguage?.language;
    } else {
      sourceLanguage = selectedSourceLanguage.language;
    }
    return sourceLanguage;
  };
  
  const showModel = () => {
    document.body.classList.add("modal-open-7");
    hideModalFun();
    setTimeout(() => {
      $(".first-focus").trigger("focus");
      $(".first-focus").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
          if (e.shiftKey === true) {
            e.preventDefault();
            $("#renameId").trigger("focus");
          }
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          document.body.classList.remove("modal-open-3");
          $('.focusAdd').trigger('focus');
          $('.inline-flex').removeClass('focusAdd');
        }
      });
    }, 500);
  };
  const handleKeyDeleteflow = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $(".first-focus").trigger("focus");
      }
    }
  };

  const getTargetLanguages = () => {
    let targetLanguages = [];
    let targetLanguageCodes = [];
    if (projectRequestIntegrationRedux?.targetLanguages && projectRequestIntegrationRedux?.targetLanguages?.length > 0) {
      projectRequestIntegrationRedux?.targetLanguages?.map((lang) => {
        targetLanguages.push({
          language: lang?.language,
          assigneeUser: null,
        });
        targetLanguageCodes.push(lang?.language);
      });
    }
    if (selectedTargetLanguages && selectedTargetLanguages?.length > 0) {
      selectedTargetLanguages?.map((lang) => {
        if (!targetLanguageCodes.includes(lang.language[0].language)) {
          targetLanguages.push({
            language: lang?.language[0]?.language,
            assigneeUser: lang?.assigneeUser,
            removed: false,
          });
        }
      });
    }
    return targetLanguages;
  };


  const confirmDelete = () => {
    let projectRequest = { ...projectRequestData }
    let data = { ...projectRequest, rejection: { reason: cancelationNotes } }
    putAxiosResponse(APIUrls.PROJECT_REQUEST_REJECT(param.id), transformBlankToNull(data)).then(res => {
      setCancelingNote("")
      setCancelingNoteLength(0)
      hideModel()
      navigate(`/project-request/show/${param.id}`)
    }).catch(err => {
      console.error(err)
    })


  };

  const setTitle = () => {
    if (projectRequestIntegrationRedux.contentType === Constants.MARKETOREST) {
      return "Marketo v2.0 assets"
    } else if (projectRequestIntegrationRedux.contentType === Constants.ELOQUA) {
      return "Eloqua assets"
    } else if (projectRequestIntegrationRedux.contentType === Constants.BRIGHTCOVE) {
      return "Brightcove assets"
    }
    return ""
  }

  const openIntegrationModel = () => {
    document.body.classList.add("modal-open");
    hideModalFun();
  };

  const hideModel = () => {
    document.body.classList.remove("modal-open-7");
    setCancelingNote("")
    setCancelingNoteLength(0)
  };

  const openIntegration = (event, contentType, contentName, requestType) => {
    $("#project-request-source-material").addClass("hide").removeClass("checked");
    if (selectedDepartment?.id) {
      setContentType(contentType);
      setContentName(contentName);
      setRequestType(requestType);
      //dispatchToProjectRequestIntegrationRedux("contentType", contentType);
      dispatchToProjectRequestIntegrationRedux("contentName", contentName);
      dispatchToProjectRequestIntegrationRedux("isProjectRequest", true);
      openIntegrationModel();
      setshowIntegration(true);
    } else {
      setshowIntegration(false);
      setValidationErrors({ userGroup: "Select Department" });
      $(".integration-check-input").prop("checked", false);
    }
  };

  const cancelationNoteFun = (event) => {
    setCancelingNote(event?.target?.value)
    setCancelingNoteLength(event?.target?.value?.length)
  }

  const crumbs = [
    { label: "Project requests", url: "project-request/list" },
    { label: `Project request - ${requestName}`, url: `project-request/show/${param.id}` },
    { label: "Edit Project Request", url: '' },
  ];

  const changeAssignee=(event,userIndex)=>{
   let targetLanguageArray=[...selectedTargetLanguages]
   
   const targetLanguage=targetLanguageArray.map((data,index)=>{
        if(index===userIndex) {
          return {
            assigneeUser:event?.data,
            language:data?.language
          }
        }    
      return data; 
   })
   setSelectedTargetLanguages(targetLanguage)
  }


  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap campaign-section">
          <Breadcrumb crumbs={crumbs} />
            <div className="translate-request-page">
              {loader ? (
                <div className="gb-overlay show">
                  <div className="gb-loader">
                    <RotatingLines strokeColor="#0096FF" strokeWidth="5" width="196" visible={true} />
                  </div>
                </div>
              ) : (
                <div className="white-bg mar-bot50">
                  <div className="translate-heading">
                    <button className="back-btn" aria-label="back" onClick={() => navigate(`/project-request/show/${param.id}`)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
                        <path
                          d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                          fill="#4D4D4D"></path>
                      </svg>
                      &nbsp; &nbsp; &nbsp; <h4>Translation Request</h4>
                    </button>
                    <p>Enter your translation request details below. Add as much detail as you can to make sure your translation projects runs smoothly</p>
                  </div>
                  <div className="flex wrap-dropdown wrap-dropdown-gap">
                    <div className="global-dropdown-block flex-center">
                      <label>Department</label>
                      <Select
                        classNamePrefix="cw"
                        aria-label="department"
                        className="global-dropdown-select"
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        options={departments}
                        onChange={(e) => selectDepartment(e)}
                        placeholder="Select One"
                        defaultValue={{ label: "Select Department" }}
                        value={departments.filter(function (option) {
                          return option?.value?.id === selectedDepartment?.id;
                        })}
                      />
                      {validationErrors.userGroup ? <div className="error">{validationErrors.userGroup}</div> : null}
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label>
                        Request Name 
                      </label>
                      <input type="text" aria-label="request name" className="form-control-sm" title="50 Characters Left" value={requestName} onChange={(e) => setRequestName(e.target.value)} />
                      {validationErrors.name ? <div className="error">{validationErrors.name}</div> : null}
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label>Campaign</label>
                      <Select
                        classNamePrefix="cw"
                        aria-label="campaign"
                        className="global-dropdown-select"
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        options={campaigns}
                        isLoading={isLoading}
                        onChange={(e) => selectCampaign(e)}
                        placeholder="Select One"
                        defaultValue={{ label: "Select Campaign" }}
                        value={campaigns.filter(function (option) {
                          return option.value.id === selectedCampaign.id;
                        })}
                      />
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label>
                        Priority <span>Optional</span>
                      </label>
                      <Select
                        aria-label="priority"
                        classNamePrefix="cw"
                        aria-required="false"
                        className="global-dropdown-select"
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        defaultValue={{ label: "Select Priority" }}
                        options={priorities}
                        onChange={(e) => selectPriority(e)}
                        value={priorities.filter(function (option) {
                          return option.value === selectedPriority;
                        })}
                      />
                    </div>
                    <div className="global-dropdown-block flex-right">
                    <div className="tooltip-container">

           <label>Translations Due Date ?</label>

<p
  tabIndex={0} data-events={['focus']} 
  data-padding="10px 10px 10px 10px"
  data-place="right"
  data-tip={translate('translation.due_date')}
  data-for="transalationToolTip"
>
  
  <svg
  
    className="svg-tooltip-icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
  </svg>
</p>
<ReactTooltip
aria-label={translate('translation.due_date')}
  className="tooltip"
  tabIndex={0}
  id="transalationToolTip"
  delayHide={1000}
>
  {translate('translation.due_date')}
</ReactTooltip>
</div>

                      <div className="flex-center w-d100">
                        <div className="global-dropdown-select " >
                          <button
                            onClick={(e) => { showCalendarDiliveryDate(e) }}
                            onKeyDown={(e) => closeCalendar(e)}
                            ref={refToggle2}
                            aria-label={translationDueDate !== "" ? `translation due date ${dateUtil.format(translationDueDate,null,null)} selected` : ""}
                            tabIndex={0}
                            aria-expanded={toggleIntialCal ? 'true':'false'}
                            type="button"
                            className="drop-down-btn gb-dropBtn">
                            <span>{<DateFormat date={translationDueDate} timezone={null}/>}
                            </span>
                            <span className="font-zero">{translationDueDate !== ""? <DateFormat date={translationDueDate} timezone={null}/>:"translation due Date"}</span>
                            <svg aria-hidden="true" className="calender-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none">
                              <path
                                d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
                                fill="#3564EB"
                              />
                            </svg>
                          </button>
                        </div>

                        {toggleIntialCal ? (
                          <div
                            ref={refCalendar2}
                            onKeyDown={(e) => {
                              closeCalendar(e);
                            }}>
                            <DatePickerCalendar
                              value={new Date()}
                              className="dashCalendarInternal"
                              minDate={new Date()}
                              selectDate={handleTranslationDueDate}
                              />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      {validationErrors.translationDueDate ? <div className="error">{validationErrors.translationDueDate}</div> : null}
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label>
                        Purchase Order Number <span>Optional</span>
                      </label>
                      <Select
                        classNamePrefix="cw"
                        className="global-dropdown-select"
                        aria-required="false"
                        aria-label="Purchase order number"
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        defaultValue={{ label: "Select Purchase Order Number" }}
                        options={poNumbers}
                        onChange={(e) => selectPONumber(e)}
                        value={poNumbers.filter(function (option) {
                          return option.value.id === selectedPONumber.id;
                        })}
                      />
                    </div>
                    <div className="global-dropdown-block flex-center w-d100">
                      <label>
                        Notes and Instructions <span>Optional</span>
                      </label>
                      <textarea aria-required="false" aria-label="Notes and Instructions" className="textarea" placeholder="2000 character limit" value={requestNote} onChange={(e) => setRequestNote(e.target.value)}></textarea>
                    </div>
                    <div className="global-dropdown-block flex-center">
                      <label>Tags</label>
                      <Select
                        classNamePrefix="cw"
                        aria-label="tags"
                        isSearchable={false}
                        className="global-dropdown-select"
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        placeholder="Select or enter a tag"
                        defaultValue={{ label: "Select or enter a tag" }}
                        options={filteredTags}
                        onChange={(e) => selectTag(e.value)}
                        onKeyDown={(e) => selectTagKeyDown(e)}
                        value={{ label: "Select or enter a tag" }}
                      />
                      <div className="multiselect-output flex">
                        {selectedTags.map((tag, tagIndex) => {
                          return (
                            <button id={`remove-lang-${tagIndex}`} aria-label={`remove ${tag?.display}`} key={tagIndex} onClick={() => removeTag(tag,tagIndex)}>
                              <strong>{tag?.display}</strong>
                              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                                <path
                                  d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                  stroke="#213248"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"></path>
                              </svg>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  </div>

                  <h5 className="heading-width-border mar-bot30">Source Materials</h5>
                  {validationErrors.sourceMaterial ? <div className="error">{validationErrors.sourceMaterial}</div> : null}
                  <div className="translate-source-block">
                    <div className="upload-list materials-tab-content mar-bot20">
                      <div className="radio-form-check">
                        <input type="radio" className="form-check-input openOption" name="radio" id="uploadRadio"
                          defaultChecked={projectRequestData && projectRequestData.sourceMaterial?.length > 0 ? true : ""} />
                        <label className="form-check-label" htmlFor="uploadRadio">
                          Upload your source materials (can be any file type). Create a .zip file to upload multiple files.
                        </label>
                      </div>
                      <div id="project-request-source-material" className={projectRequestData?.sourceMaterial?.length > 0 ? "hide checked" : "hide"}>
                        <SourceMaterialUpload selectedSourceMaterial={projectRequestData} funct={getProjectData} />
                      </div>
                    </div>
                    <div className="sourc-material-addlink mar-bot20">
                      <div className="radio-form-check">
                        <input type="radio" className="form-check-input openOption" name="radio" id="addLink" defaultChecked={sourceMaterialDescription?.length > 0 ? true : false} />
                        <label className="form-check-label" htmlFor="addLink">
                          Add link or description of your source material
                        </label>
                      </div>
                      <div className={sourceMaterialDescription?.length > 0 ? "global-dropdown-block mb-0 w-d100" : "global-dropdown-block mb-0 w-d100 hide"}>
                        <textarea
                          className="textarea" placeholder="1000 characters limit" maxLength={1000}
                          defaultValue={sourceMaterialDescription}
                          onChange={(event) => setSourceMaterialDescription(event.target.value)}
                        />
                      </div>
                    </div>
                    {permissions?.ELOQUA_ACCESS && (
                      <div className="eloqua-assets mar-bot20">
                        <div className="radio-form-check">
                          <input
                            type="radio"
                            className="form-check-input integration-check-input"
                            name="radio"
                            id="eloquaAssets"
                            onChange={(event) => openIntegration(event, Constants.ELOQUA, Constants.ELOQUA_CONTENT_TYPE_DISPLAY, "eloqua")}
                          />
                          <label className="form-check-label" htmlFor="eloquaAssets">
                            Select your Eloqua Assests
                          </label>
                        </div>
                      </div>
                    )}
                    {permissions?.MARKETOREST_ACCESS && (
                      <div className="marketo-assets mar-bot20">
                        <div className="radio-form-check">
                          <input
                            type="radio"
                            className="form-check-input integration-check-input"
                            name="radio"
                            id="marketoAssets"
                            onChange={(event) => openIntegration(event, Constants.MARKETOREST, Constants.MARKETOREST_CONTENT_TYPE_DISPLAY, "marketov2")}
                          />
                          <label className="form-check-label" htmlFor="marketoAssets">
                            Select your Marketo v2.0 Assests
                          </label>
                        </div>
                      </div>
                    )}
                    {permissions?.BRIGHTCOVE_ACCESS && (
                      <div className="brightcove-assets mar-bot20">
                        <div className="radio-form-check">
                          <input
                            type="radio"
                            className="form-check-input integration-check-input"
                            name="radio"
                            id="brightcoveAssets"
                            onChange={(event) => openIntegration(event, Constants.BRIGHTCOVE, Constants.BRIGHTCOVE_CONTENT_TYPE_DISPLAY, "brightcove")}
                          />
                          <label className="form-check-label" htmlFor="brightcoveAssets">
                            Select your Brightcove Assests
                          </label>
                        </div>
                      </div>
                    )}
                    {projectRequestIntegrationRedux.selectedAssets?.length > 0 ? (
                      <>
                        <div className="datatable-block custom_width">
                          <DataTable
                            columns={assetColumns}
                            data={projectRequestIntegrationRedux.selectedAssets}
                            highlightOnHover
                            responsive
                            striped
                            selectableRowsHighlight={true}
                            defaultSortFieldId={1}
                            theme={theme}
                            title={setTitle()}
                          />
                        </div>
                        <br />
                      </>
                    ) : (
                      <div className="step-2-section mar-bot30">
                        <div className="flex wrap-dropdown mb-0">
                          <div className="global-dropdown-block">
                            <label>What is your source language?</label>
                            <Select
                              classNamePrefix="cw"
                              className="global-dropdown-select"
                              aria-label="source language"
                              menuShouldScrollIntoView={false}
                              closeMenuOnSelect={true}
                              defaultValue={{ label: "Select Source Language" }}
                              options={sourceLanguages}
                              onChange={(e) => handleSourceLanguageChange(e)}
                              value={sourceLanguages.filter(function (option) {
                                return option.value.code === selectedSourceLanguage.code;
                              })}
                            />
                            {validationErrors.sourceLanguage ? <div className="error">{validationErrors.sourceLanguage}</div> : null}
                          </div>
                          <div className="cust-arrow"></div>
                          <div className="global-dropdown-block">
                          <div className="tooltip-container">

<label>What languages do you want to translate to ?    </label>

<p
  tabIndex={0} data-events={['focus']} data-eventsoff={['blur']}
  data-padding="10px 10px 10px 10px"
  data-place="right"
  data-tip={Constants.TARGET_LANGUAGE_TOOLTIP}
  data-for="targetLanguageTooltip"
>
  <svg
    className="svg-tooltip-icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
  </svg>
</p>
<ReactTooltip
  className="tooltip"
  id="targetLanguageTooltip"
  delayHide={1000}
>
  <a href="#">Target Languages</a><br></br>
  {Constants.TARGET_LANGUAGE_TOOLTIP}
</ReactTooltip>
</div>
                            <Select
                              classNamePrefix="cw"
                              aria-label="target langauge"
                              className="global-dropdown-select"
                              menuShouldScrollIntoView={false}
                              closeMenuOnSelect={true}
                              defaultValue={{ label: "Select Target Language" }}
                              options={filteredTargetLanguage}
                              isDisabled={selectedSourceLanguage === ""}
                              onChange={(e) => handleTargetLanguageChange(e)}
                              value={filteredTargetLanguage.filter(function (option) {
                                return option.value.code === selectedTargetLanguages.code;
                              })}
                            />
                            {validationErrors.requestTargetLanguages ? <div className="error">{validationErrors.requestTargetLanguages}</div> : null}
                            {userBootstrapData?.roleSet?.value ==='ROLE_CUSTOMER_PROJECT_REQUESTER' && selectedTargetLanguages && selectedTargetLanguages?.length > 0?
                            selectedTargetLanguages.map((selectedTargetLangs,index)=>( <div className="multiselect-output flex">
                            <button aria-label={`remove ${selectedTargetLangs?.display}`} key={index} onClick={() => removeTargetLanguage(selectedTargetLangs)}>
                        <strong>{selectedTargetLangs?.language[0]?.display}</strong>
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                          <path
                            d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                            stroke="#213248"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"></path>
                        </svg>
                      </button>
                      </div>)):Constants.BLANK}
                            
                          </div>
                          {userBootstrapData?.roleSet?.value ==='ROLE_CUSTOMER_PROJECT_REQUESTER'?Constants.BLANK:
                          <div className="table-responsive global-table project-request">                           
                                    <table className="bids-table-list relative 1" aria-label="Bid History">
                                      <thead>
                                        <tr>
                                          <th className="width-auto">Language	</th>
                                          <th className="align-left">Assignee</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                      {selectedTargetLanguages && selectedTargetLanguages?.length > 0?
                                    selectedTargetLanguages.map((selectedTargetLangs,index)=>(
                                      <tr key={index}>
                                      <td className="width-auto">
                                      <div className="multiselect-output flex">
                                        <button aria-label={`remove ${selectedTargetLangs?.display}`} key={index} onClick={() => removeTargetLanguage(selectedTargetLangs)}>
                                    <strong>{selectedTargetLangs?.language[0]?.display}</strong>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                                      <path
                                        d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                        stroke="#213248"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"></path>
                                    </svg>
                                  </button>
                                  </div>
                                  	</td>
                                      <td>
                                        <div className="global-dropdown-block m-0 wd-200">
                                        <Select
                                          classNamePrefix="cw" 
                                          className="global-dropdown-select align-left"
                                          onChange={(event)=>changeAssignee(event,index)}
                                           placeholder={'Unassigned'} 
                                           value={allAssignedUser?.filter(data=>data?.value ===selectedTargetLangs?.assigneeUser?.userId)}
                                           options={allAssignedUser} /></div>
                                      </td>
                                    </tr>
                                    )):Constants.BLANK  
                                    }
                                      </tbody>
                                    </table>
                          </div>}
                        </div>
                      </div>
                    )}
                  </div>
                  <h5 className="heading-width-border mar-bot30">Project Reference Matrials</h5>
                  <div className="project-ref-matrial materials-tab-content">
                    <ReferenceMaterialUpload selectedReferenceMaterial={projectRequestData} funct={getProjectData} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
      {showIntegration && (
        <div>
          <ProjectRequestIntegrationMemo
            contentType={contentType}
            contentName={contentName}
            department={selectedDepartment}
            projectRequestId={projectRequestId}
          />
        </div>

      )}

      <div className='lightbox-panel' id="modal-open-7" aria-labelledby="removelabel" aria-modal="true" role="dialog">
        <div className="inner-lightbox-panel pb-0">
          <div className="modal-header flex padd-lr">
            <h5 id="removelabel">Cancel Project Request</h5>
          </div>
          <div className="lightbox-content padd-22">
            <p className="f16-para">
              Please provide a reason for canceling this request:
            </p>
            <>
              <div >
                <textarea value={cancelationNotes} onChange={cancelationNoteFun} className="textarea" />
              </div>
              <small>{500 - cancelationNotesLength} characters left</small>
            </>
          </div>
          <div className="modal-footer modal-footer-border flex px-22">
            <button className="btn btn-bold first-focus" onClick={hideModel}>Cancel</button>
            <button disabled={cancelationNotesLength === 0} onClick={() => confirmDelete()} className="btn btn-bold active" onKeyDown={handleKeyDeleteflow} id="renameId">Submit</button>
          </div>
        </div>
      </div>


      <div className="stricy-btn flex flex-center no-rightlist justify-center">
        {permissions?.PROJECT_REQUEST_ASSIGNABLE && projectRequestData?.status === 'OPEN' || projectRequestData?.status === 'ACCEPTED' ?
          <div>
            <button onClick={showModel} className="btn-default">
              Cancel Project Request
            </button>
          </div>
          : Constants.BLANK}

        <div className="left flex">
          <div>
            <button
              className="btn-default"
              onClick={() => {
                navigate("/project-request/show/" + projectRequestId);
              }}>
              Cancel
            </button>
          </div>

          <div>
            <button className="btn-default" onClick={updateRequest}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
